import FormConfig from './ConfigurationFormConfig';
import AjaxUtility from '../Utility/AjaxUtility';
import MathUtility from '../Utility/MathUtility';
import RainwaterSelectionMap from "./RainwaterSelectionMap";
import RainwaterSelectionMapAt from "./RainwaterSelectionMapAt";

export default class ConfigurationForm {

	constructor() {
		this.form = $(FormConfig.selectors.configurationForm);
		// Continue only on form page
		if (this.form.length) {
			this.coefficientSteps = -0.05;
			this.areaTypeCount = $(FormConfig.selectors.areaTypeBlock).length;
			this.areaTypeMax = 14;
			this.country = FormConfig.values.countries.GERMANY;
			this.rainwaterSelectionMap = null;
			this.rcIndexInput = $(FormConfig.selectors.rcIndexInput);
			this.rcIndex = this.rcIndexInput.val();
			this.rcIndexChanged = this.form.data('rcindexchanged') === 1;

			this.runoffTypes = {};

			this.customRunoffValueInput = $(FormConfig.selectors.customRunoffValueInput);
			this.customRunoffValueSignificand = $(FormConfig.selectors.customRunoffValueSignificand);
			this.customRunoffValueExponent = $(FormConfig.selectors.customRunoffValueExponent);
			this.runoffValueIndexNotationResult = $(FormConfig.selectors.runoffValueIndexNotationResult);
			this.weatherStation = $(FormConfig.selectors.weatherStation);

			if (this.customRunoffValueSignificand.length && this.customRunoffValueExponent.length) {
				this.setCustomRunoffValueIndexNotation();
				this.resolveCustomRunoffValueIndexNotation();
			}

			$(FormConfig.selectors.areaTypeSelect).each((index, element) => {
				this.fillAreaTypeData($(element), parseInt(element.value), true);
			});

			const resultMessageContainer = $(FormConfig.selectors.weatherStationCheckResult);
			if (resultMessageContainer.length > 0 && resultMessageContainer.html().length > 0) {
				resultMessageContainer.show();
			}

			if ($(FormConfig.selectors.groundReportFilesUploadHidden).prop('checked')) {
				this.activateGroundReportFilesUpload();
			}

			this.bindHandlers();

			const propertyZipInput = $(FormConfig.selectors.propertyZipInput);


			if (propertyZipInput.val() === '') {
				$(FormConfig.selectors.changeWeatherStation).hide();
			}

			if(!this.rcIndex || this.rcIndex === '') {
				let ajaxFinished;
				if (propertyZipInput.length && propertyZipInput.val() !== '') {
					ajaxFinished = this.checkWeatherStation(propertyZipInput.val(), FormConfig.selectors.propertyCityDisplay);
				}

				// Check if manual weather station should be displayed AFTER checkWeatherStation method ist done
				if (ajaxFinished !== undefined) {
					ajaxFinished.done(() => this.showManualWeatherStation());
				}
			}

			this.toggleRemoveButtons();

			// fancybox settings
			$.fancybox.defaults = $.extend($.fancybox.defaults, {
				maxWidth: 1080,
				helpers: {
					overlay: {
						locked: false
					}
				}
			});

			$('.fancybox').not('.iframe').fancybox();

			$('.fancybox.iframe').fancybox({
				type: 'iframe'
			});

			this.setWeatherStationManually();

			// VSO-334: Prevent submit with ENTER
			this.form.keydown(function(event) {
				if(event.keyCode === 13) {
					event.preventDefault();
					return false;
				}
			});
		}
	}

	bindHandlers() {
		const infiltrationRadios = $(FormConfig.selectors.infiltrationType);
		infiltrationRadios.on('click', e => {
			this.infiltrationTypeChange(parseInt(e.target.value));
		});
		this.infiltrationTypeChange(parseInt(infiltrationRadios.filter(':checked').val()));

		const countryRadios = $(FormConfig.selectors.country);
		countryRadios.on('click', e => {
			this.countryChange(parseInt(e.target.value), true);
		})
		this.countryChange(parseInt(countryRadios.filter(':checked').val()));

		const attenuationPlusCheckbox = $(FormConfig.selectors.attenuationPlusCheckbox);
		attenuationPlusCheckbox.on('click', e => {
			this.attenuationPlusChange($(FormConfig.selectors.attenuationPlusCheckbox));
		});
		this.attenuationPlusChange($(FormConfig.selectors.attenuationPlusCheckbox));

		this.customRunoffValueInput.hide();
		// show javascript based index notation input
		$(FormConfig.selectors.customRunoffValueIndexNotation).show();

		this.customRunoffValueSignificand
			.add(this.customRunoffValueExponent)
			.on('change keyup', e => {
				this.resolveCustomRunoffValueIndexNotation();
			});

		$(FormConfig.selectors.addAreaTypeButton).on('click', e => {
			e.preventDefault();

			this.addAreaType();
			return false;
		});

		this.bindPermittedDischargeHandlers();
		this.bindAreaTypeSelectHandlers();

		const resilienceRadios = $(FormConfig.selectors.resilienceRadio);
		resilienceRadios.on('click', e => {
			this.resilienceChange(e.target.value);
		});
		this.resilienceChange(parseInt(resilienceRadios.filter(':checked').val()));

		const assignedTeamSelect = $(FormConfig.selectors.assignedTeamSelect);
		assignedTeamSelect.on('change', e => {
			this.updateProcessorSelect(e.target.value);
		});

		const propertyZipInput = $(FormConfig.selectors.propertyZipInput);
		propertyZipInput.on('blur', e => {
			if (this.country === FormConfig.values.countries.GERMANY) {
				this.checkWeatherStation(e.value, FormConfig.selectors.propertyCityDisplay);
			}
		});
		propertyZipInput.on('change', e => {
			this.resetWeatherStationCheck();
		});

		const configurationSubmit = $(FormConfig.selectors.configurationSubmit);
		configurationSubmit.on('click', e => {
			this.beforeSubmit(e);
		});

		const changeWeatherStation = $(FormConfig.selectors.changeWeatherStation);
		changeWeatherStation.on('click', e => {
			this.setWeatherStationManually();
		});

		const
			groundReportInfoStep1 = $(FormConfig.selectors.groundReportInfoStep1),
			groundReportInfoStep2 = $(FormConfig.selectors.groundReportInfoStep2),
			activateGroundReportFilesUploadButton = $(FormConfig.selectors.activateGroundReportFilesUploadButton),
			confirmGroundReportFilesUpload = $(FormConfig.selectors.confirmGroundReportFilesUpload),
			cancelGroundReportFilesUpload = $(FormConfig.selectors.cancelGroundReportFilesUpload);

		activateGroundReportFilesUploadButton.on('click', e => {
			e.preventDefault();
			groundReportInfoStep1.hide();
			groundReportInfoStep2.show();
			confirmGroundReportFilesUpload.show();
			$.fancybox.update();

			confirmGroundReportFilesUpload.on('click', e => {
				e.preventDefault();
				confirmGroundReportFilesUpload.off('click');
				confirmGroundReportFilesUpload.hide();
				this.activateGroundReportFilesUpload();
				$.fancybox.close();
			});
		});
		cancelGroundReportFilesUpload.on('click', e => {
			e.preventDefault();
			confirmGroundReportFilesUpload.off('click');
			this.deactivateGroundReportFilesUpload();
			groundReportInfoStep2.hide();
			groundReportInfoStep1.show();
			$.fancybox.update();
		});

		const fancyboxClosers = $('.closeFancybox');
		fancyboxClosers.on('click', e => {
			e.preventDefault();
			$.fancybox.close();
		});

		const clientTypeSelect = $(FormConfig.selectors.clientTypeSelect);
		clientTypeSelect.on('change', e => {
			this.customerTypeBasedToggles(parseInt(clientTypeSelect.val()));
		});
		this.customerTypeBasedToggles(parseInt(clientTypeSelect.val()));

		const grafPartnerCheckbox = $(FormConfig.selectors.grafPartnerCheckbox);
		grafPartnerCheckbox.on('change', e => {
			this.grafPartnerCheckboxToggle(grafPartnerCheckbox.prop('checked'));
		});
		this.grafPartnerCheckboxToggle(grafPartnerCheckbox.prop('checked'));
	}

	bindAreaTypeSelectHandlers() {
		$(FormConfig.selectors.areaTypeSelect).off('change');
		$(FormConfig.selectors.areaTypeSelect).on('change', e => {
			this.fillAreaTypeData($(e.target), parseInt(e.target.value));
		});

		$(FormConfig.selectors.runofftypeSelect).off('change');
		$(FormConfig.selectors.runofftypeSelect).on('change', e => {
			let $areaTypeBlock = $(e.target).parents(FormConfig.selectors.areaTypeBlock),
				optionData = $(e.target.options[e.target.selectedIndex]).data();

			this.fillCoefficientSelect($areaTypeBlock, optionData);
		});

		$(FormConfig.selectors.removeAreaTypeButton).off('click');
		$(FormConfig.selectors.removeAreaTypeButton).on('click', e => {
			e.preventDefault();
			let $areaTypeBlock = $(e.target).parents(FormConfig.selectors.areaTypeBlock);

			this.removeAreaType($areaTypeBlock);
			return false;
		});
	}

	bindPermittedDischargeHandlers() {
		const
			permittedDischarge = $(FormConfig.selectors.permittedDischargeInput),
			permittedDischargeUnit = $(FormConfig.selectors.permittedDischargeUnitInput),
			rainDrainage = $(FormConfig.selectors.rainDrainageInput),
			rainDrainageArea = $(FormConfig.selectors.rainDrainageAreaInput),
			ignorePermittedDischarge = $(FormConfig.selectors.ignorePermittedDischargeCheckbox);

		// Initialize and check, if values exist (form was submitted)
		if (rainDrainageArea.val() > 0 && rainDrainage.val() > 0) {
			permittedDischarge.prop('disabled', true);
		} else if (permittedDischarge.val() > 0) {
			rainDrainage.prop('disabled', true);
			rainDrainageArea.prop('disabled', true);
		}
		if (permittedDischargeUnit.val() == 1) {
			permittedDischarge.prop('placeholder', permittedDischarge.data('placeholder-lmin'));
		}

		// Change placeholder if unit is changed
		permittedDischargeUnit.on('change keyup', e => {
			this.validatePermittedDischarge();

			if (permittedDischargeUnit.val() == 1) {
				permittedDischarge.prop('placeholder', permittedDischarge.data('placeholder-lmin'));
			} else {
				permittedDischarge.prop('placeholder', permittedDischarge.data('placeholder-ls'));
			}
		});
		// Validate permittedDischarge if ignorePermittedDischarge is changed
		ignorePermittedDischarge.on('click', e => {
			this.validatePermittedDischarge();
		});

		// Disable rainDrainage if permittedDischarge is changed
		permittedDischarge.on('change keyup', e => {
			this.validatePermittedDischarge();

			if (permittedDischarge.val() === '' || permittedDischarge.val() == 0) {
				rainDrainage.prop('disabled', false);
				rainDrainageArea.prop('disabled', false);
			} else {
				rainDrainage.prop('disabled', true);
				rainDrainageArea.prop('disabled', true);

			}
		});
		// Disable permittedDischarge if rainDrainage is changed
		rainDrainage.on('change keyup', e => {
			if (rainDrainage.val() === '' || rainDrainage.val() == 0) {
				permittedDischarge.prop('disabled', false);
			} else {
				permittedDischarge.prop('disabled', true);
			}
		});
	}

	validatePermittedDischarge() {
		const
			permittedDischarge = $(FormConfig.selectors.permittedDischargeInput),
			permittedDischargeUnit = $(FormConfig.selectors.permittedDischargeUnitInput),
			ignorePermittedDischarge = $(FormConfig.selectors.ignorePermittedDischargeCheckbox),
			permittedDischargeError = $(FormConfig.selectors.permittedDischargeError);

		if (ignorePermittedDischarge.is(':checked') || permittedDischarge.val() === '' || permittedDischarge.val() == 0) {
			permittedDischargeError.remove();
			return;
		}

		let inputVal = parseFloat(permittedDischarge.val().replace(",", ".")),
			min = permittedDischarge.data('min-ls'),
			max = permittedDischarge.data('max-ls'),
			errorMessage = permittedDischarge.data('placeholder-ls');
		if (permittedDischargeUnit.val() == 1) {
			min = permittedDischarge.data('min-lmin');
			max = permittedDischarge.data('max-lmin');
			errorMessage = permittedDischarge.data('placeholder-lmin');
		}

		if (inputVal < min || inputVal > max) {
			permittedDischargeError.remove();
			permittedDischarge.after('<p class="error" id="permittedDischargeError">' + errorMessage + '</p>');
		} else {
			permittedDischargeError.remove();
		}
	}

	/**
	 * Switch infiltrationType dependent form fields
	 * Also disable products based on infiltration type (and resilience)
	 *
	 * @param infiltrationType
	 */
	infiltrationTypeChange(infiltrationType) {
		if([FormConfig.values.infiltrationType.RIGOLE, FormConfig.values.infiltrationType.TROUGH_RIGOLE].includes(infiltrationType)) {
			$(FormConfig.selectors.rigoleOnly).show();
			$(FormConfig.selectors.retentionOnly).hide();
			// disable all retention fields so they do not get submitted
			$(FormConfig.selectors.retentionOnly + ' input').prop('disabled', true);
		}

		if(FormConfig.values.infiltrationType.RETENTION_CISTERN === infiltrationType) {
			$(FormConfig.selectors.retentionOnly).show();
			$(FormConfig.selectors.retentionOnly + ' input').prop('disabled', false);
			$(FormConfig.selectors.rigoleOnly).hide();
		}

		// VSO-309: add rainwater utilisation also to rigole
		if ([FormConfig.values.infiltrationType.RIGOLE, FormConfig.values.infiltrationType.RETENTION_CISTERN].includes(infiltrationType)) {
			$(FormConfig.selectors.rainwaterUtilisationOnly).show();
			$(FormConfig.selectors.rainwaterUtilisationOnly + ' input').prop('disabled', false);
			// only activate attenuationPlus inputs if checkbox is checked!
			if ($(FormConfig.selectors.attenuationPlusCheckbox).prop('checked') !== true) {
				$(FormConfig.selectors.attenuationPlusRow + ' input').prop('disabled', true);
			}
		} else {
			$(FormConfig.selectors.rainwaterUtilisationOnly).hide();
			// disable all rainwater utilisation fields so they do not get submitted
			$(FormConfig.selectors.rainwaterUtilisationOnly + ' input').prop('disabled', true);
		}

		// disable products based on infiltration type and resilience
		let $resilienceId = $(FormConfig.selectors.resilienceRadio + ':checked').val();
		this.updateDisabledProducts($resilienceId, infiltrationType);
	}

	countryChange(country, activeChange = false) {
		this.country = country;

		// Manipulate rain frequency select for CH
		const rainFrequencySelect = $(FormConfig.selectors.rainFrequencySelect)[0];
		const defaultOptionText = rainFrequencySelect.dataset.defaultOptionText;
		// Get select options
		let rainFrequencyOptions = rainFrequencySelect.options;
		// Default: hide 15 years and show 50 and 100 years
		let hideOptions = [2];
		let showOptions = [5, 6];
		// Default selected value = 5 years
		let defaultValue = '5';
		// Add default text to 5 years (option 0) and remove from 10 years (option 1, if set by CH)
		let addDefaultTextIndex = 0;
		let removeDefaultTextIndex = 1;

		if (country === FormConfig.values.countries.SWITZERLAND) {
			hideOptions = [5, 6];
			showOptions = [2];
			defaultValue = '10';
			addDefaultTextIndex = 1;
			removeDefaultTextIndex = 0;
		}

		// Set current default (selected) value for select, if country was changed
		if (activeChange) {
			rainFrequencySelect.value = defaultValue;
		}
		// Add and remove default text
		if (rainFrequencyOptions[addDefaultTextIndex].innerHTML.indexOf(defaultOptionText) === -1) {
			rainFrequencyOptions[addDefaultTextIndex].innerHTML = rainFrequencyOptions[addDefaultTextIndex].innerHTML + defaultOptionText;
		}
		if (rainFrequencyOptions[removeDefaultTextIndex].innerHTML.indexOf(defaultOptionText) !== -1) {
			rainFrequencyOptions[removeDefaultTextIndex].innerHTML = rainFrequencyOptions[removeDefaultTextIndex].innerHTML.replace(defaultOptionText, '');
		}

		// VSOAT-55: Stop at this point, if country is Austria. Do not change weather station selection or hide any options
		if (country === FormConfig.values.countries.AUSTRIA) {
			$(FormConfig.selectors.propertyCityDisplay).hide();
			$(FormConfig.selectors.propertyCityInput).show();
			$(FormConfig.selectors.changeWeatherStation).hide();
			return;
		}

		if (country === FormConfig.values.countries.GERMANY) {
			// return to default
			this.weatherStation.show();
			$(FormConfig.selectors.propertyCityDisplay).show();
			$(FormConfig.selectors.propertyCityInput).hide();
			if ($(FormConfig.selectors.propertyZipInput).val() !== '') {
				$(FormConfig.selectors.changeWeatherStation).show();
			}
		} else {
			// switch to new mode
			this.weatherStation.hide();
			$(FormConfig.selectors.propertyCityDisplay).hide();
			$(FormConfig.selectors.propertyCityInput).show();
			$(FormConfig.selectors.changeWeatherStation).hide();

			if (this.rainwaterSelectionMap) {
				this.rainwaterSelectionMap.hide();
			}
		}

		// Hide options
		hideOptions.forEach(option => {
			rainFrequencyOptions[option].setAttribute('hidden', 'hidden');
		});
		// Show options
		showOptions.forEach(option => {
			rainFrequencyOptions[option].removeAttribute('hidden');
		});
	}

	// show manual weather station selection if input was wrong on previous form submit
	showManualWeatherStation() {
		const
			cityInput = $(FormConfig.selectors.cityInput),
			citySelect = $(FormConfig.selectors.citySelect);
		if(
			cityInput.length > 0 && cityInput[0].value.length > 0 &&
			citySelect.length > 0 && citySelect[0].options.length === 0
		) {
			$(FormConfig.selectors.cityInput).addClass('error');
			$(FormConfig.selectors.manualWeatherStationSelection).show();
		}
	}

	// Show additional fields if attenuation plus is checked and not disabled
	attenuationPlusChange(checkbox) {
		if (!checkbox.prop('disabled') && checkbox.prop('checked')) {
			$(FormConfig.selectors.attenuationPlusRow).show();
			$(FormConfig.selectors.attenuationPlusRow + ' input').prop('disabled', false);
		} else {
			$(FormConfig.selectors.attenuationPlusRow).hide();
			// disable fields so they do not get submitted
			$(FormConfig.selectors.attenuationPlusRow + ' input').prop('disabled', true);
		}
	}

	setCustomRunoffValueIndexNotation() {
		let significand = parseFloat(this.customRunoffValueInput.val());

		if(significand > 0) {
			let exponent = 0;

			while(significand < 1 && exponent > -6) {
				significand *= 10;
				exponent--;
			}

			this.customRunoffValueSignificand.val(String(MathUtility.round(significand, 2)).replace('.', ','));
			this.customRunoffValueExponent.val(exponent);
		}
	}

	resolveCustomRunoffValueIndexNotation() {
		let significand = parseFloat(this.customRunoffValueSignificand.val().replace(',', '.')),
			exponent = parseInt(this.customRunoffValueExponent.val());

		if(significand >= 1 && significand <= 9.9) {
			this.customRunoffValueInput.prev('input').prop('checked', true);

			let customRunoffValue = String(MathUtility.resolveIndexNotation(significand, exponent)).replace('.', ',');

			this.customRunoffValueInput.val(customRunoffValue);
			this.runoffValueIndexNotationResult.html(`(${customRunoffValue})`);
		} else {
			this.customRunoffValueInput.val(0);
			this.runoffValueIndexNotationResult.html('');
		}
	}

	addAreaType() {
		if(this.areaTypeCount >= this.areaTypeMax) {
			return;
		}

		let $template = $(FormConfig.selectors.areaTypeBlock).last(),
			clone = $template.clone();

		clone.find(FormConfig.selectors.runofftypeSelect)[0].options.length = 0;
		clone.find(FormConfig.selectors.areaInput)[0].value = '';

		$template.after(clone);
		this.areaTypeCount++;

		this.updateIndexes();

		this.fillAreaTypeData(clone.find(FormConfig.selectors.areaTypeSelect), parseInt(clone.find(FormConfig.selectors.areaTypeSelect)[0].value));

		this.bindAreaTypeSelectHandlers();

		this.toggleRemoveButtons();
	}

	removeAreaType($areaTypeBlock) {
		if($(FormConfig.selectors.areaTypeBlock).length > 1) {
			$areaTypeBlock.remove();
			this.updateIndexes();
			this.areaTypeCount--;
		}

		this.toggleRemoveButtons();
	}

	updateIndexes() {
		let $blocks = $(FormConfig.selectors.areaTypeBlock);

		$blocks.each((index, block) => {
			this.setIndexes($(block).find('select, input'), index);
		});
	}

	setIndexes($elements, index) {
		$elements.each((i, element) => {
			element.name = element.name.replace(/\d/, index);
		});
	}

	toggleRemoveButtons() {
		let removeButtons = $(FormConfig.selectors.removeAreaTypeButton);
		removeButtons.toggle(removeButtons.length !== 1);

		if(this.areaTypeCount >= this.areaTypeMax) {
			$(FormConfig.selectors.addAreaTypeButton).hide();
			$(FormConfig.selectors.addAreaTypeLimitReached).show();
		} else {
			$(FormConfig.selectors.addAreaTypeButton).show();
			$(FormConfig.selectors.addAreaTypeLimitReached).hide();
		}
	}

	fillAreaTypeData($areaTypeSelect, areaType, initialFill) {
		let $areaTypeBlock = $areaTypeSelect.parents(FormConfig.selectors.areaTypeBlock);

		if(this.runoffTypes[areaType] === undefined) {
			AjaxUtility.request('Configurator', {
				controller: 'Configuration',
				action: 'getAreaTypeData',
				areaType: areaType
			}).done(response => {
				let runoffTypes = JSON.parse(response);
				// cache results
				this.runoffTypes[areaType] = runoffTypes;

				this.fillRunoffTypeSelect($areaTypeBlock, runoffTypes, initialFill);
			});
		} else {
			this.fillRunoffTypeSelect($areaTypeBlock, this.runoffTypes[areaType], initialFill);
		}
	}

	fillRunoffTypeSelect($areaTypeBlock, runoffTypes, initialFill) {
		let $runoffTypeSelect = $areaTypeBlock.find(FormConfig.selectors.runofftypeSelect);

		// clear options
		if($runoffTypeSelect[0] !== undefined) {
			let runoffTypeSelect = $runoffTypeSelect[0];
			runoffTypeSelect.options.length = 0;

			runoffTypes.forEach(element => {
				$runoffTypeSelect[0].add(
					this.createOptionElement(element.uid, element.name, [
						{
							key: 'data-coefficientfrom',
							value: element.coefficientFrom
						},
						{
							key: 'data-coefficientto',
							value: element.coefficientTo
						}
					])
				);
			});

			let initialValue = $areaTypeBlock.find(FormConfig.selectors.runofftypeValue).data('value');
			if(initialFill && initialValue) {
				$runoffTypeSelect.val($areaTypeBlock.find(FormConfig.selectors.runofftypeValue).data('value'));
			}

			this.fillCoefficientSelect($areaTypeBlock, $(runoffTypeSelect.options[runoffTypeSelect.selectedIndex]).data(), initialFill);
		}
	}

	fillCoefficientSelect($areaTypeBlock, optionData, initialFill) {
		let $coefficientSelect = $areaTypeBlock.find(FormConfig.selectors.coefficientSelect),
			coefficientSelect = $coefficientSelect[0],
			coefficient = optionData.coefficientto;

		// clear options
		coefficientSelect.options.length = 0;

		while(coefficient >= optionData.coefficientfrom) {
			coefficientSelect.options.add(
				this.createOptionElement(coefficient, coefficient)
			);

			// floating point shenanigans
			coefficient = Math.round((coefficient + this.coefficientSteps) * 100) / 100;
		}

		let initialValue = $areaTypeBlock.find(FormConfig.selectors.coefficientValue).data('value');
		if(initialFill && initialValue) {
			$coefficientSelect.val($areaTypeBlock.find(FormConfig.selectors.coefficientValue).data('value'));
		}
	}

	createOptionElement(value, label, additionalAttributes = []) {
		let option = document.createElement('option');
		option.setAttribute('value', value);
		option.innerHTML = label;

		additionalAttributes.forEach(attribute => {
			option.setAttribute(attribute.key, attribute.value);
		});

		return option;
	}

	/**
	 * Resilience info should be on page
	 *
	 * @param resilience
	 */
	resilienceChange(resilience) {
		let $infiltrationTypeId = $(FormConfig.selectors.infiltrationType + ':checked').val();
		this.updateDisabledProducts(resilience, $infiltrationTypeId);
	}

	/**
	 * Disable products based on resilience and infiltration type
	 *
	 * @param resilience
	 * @param infiltrationType
	 */
	updateDisabledProducts(resilience, infiltrationType) {
		// Enable all products
		let $productCheckboxes = $(FormConfig.selectors.productCheckbox);
		$productCheckboxes.prop('disabled', '');

		// Disable products based on resilience
		if (typeof disableResiliences !== 'undefined') {
			$productCheckboxes.each((index, element) => {
				if (disableResiliences[element.value] !== undefined && disableResiliences[element.value].indexOf(parseInt(resilience)) > -1) {
					$(element).prop('disabled', true);
				}
			});
		}

		// Disable products based on infiltrationType
		if (typeof disableProducts !== 'undefined' && disableProducts[infiltrationType] !== undefined) {
			disableProducts[infiltrationType].forEach((element) => {
				$('#product' + element).prop('disabled', true);
			});
		}
	}

	updateProcessorSelect(team) {
		AjaxUtility.request('Administration', {
			controller: 'Configuration',
			action: 'getTeamMembers',
			team: team
		}).done(response => {
			let $processorSelect = $(FormConfig.selectors.processorSelect),
				members = JSON.parse(response);
			$processorSelect[0].length = 0;

			for(const key in members) {
				$processorSelect[0].options.add(
					this.createOptionElement(key, members[key])
				);
			}
		});
	}

	/**
	 * Find the matching weather station
	 * (this should probably be a separate object)
	 *
	 * @param submitForm
	 * @param displayInputId
	 * @param zip
	 */
	checkWeatherStation(zip, displayInputId, submitForm = false) {
		if(this.country !== FormConfig.values.countries.GERMANY) {
			return;
		}

		const
			weatherStationCheckLoading = $(FormConfig.selectors.weatherStationCheckLoading),
			propertyZipInput = $(FormConfig.selectors.propertyZipInput),
			propertyCityInput = $(FormConfig.selectors.propertyCityInput),
			citySelect = $(FormConfig.selectors.citySelect),
			cityInput = $(FormConfig.selectors.cityInput),
			resultMessageContainer = $(FormConfig.selectors.weatherStationCheckResult),
			displayInput = $(displayInputId);

		weatherStationCheckLoading.show();

		if(!zip && propertyZipInput.length) {
			zip = propertyZipInput[0].value;
		}

		return AjaxUtility.request('Configurator', {
			controller: 'Configuration',
			action: 'checkWeatherStation',
			zip: zip
		}).done(response => {
			const
				data = JSON.parse(response),
				message = data.message,
				city = data.city;

			this.rcIndex = data.rcIndex;

			resultMessageContainer.html(message);
			resultMessageContainer.toggle(message.length > 0);
			resultMessageContainer.toggleClass('error', data.error);
			weatherStationCheckLoading.hide();

			// set result if it was unambiguous
			if(city.uid !== undefined) {
				citySelect.html('');
				citySelect.append(`<option value="${city.uid}">${city.name}</option>`);
				citySelect[0].value = city.uid;
				if(displayInputId === FormConfig.selectors.propertyCityDisplay) {
					propertyCityInput[0].value = city.name;
				}
				if(displayInputId) {
					displayInput[0].value = city.name + '**';
				}

				cityInput.prop('required', false);

				if(submitForm) {
					this.form.submit();
				}

				if(this.rainwaterSelectionMap === null) {
					$(FormConfig.selectors.changeWeatherStation).show();
				}

				if(this.rainwaterSelectionMap) {
					this.rainwaterSelectionMap.setViewToGridFeature(this.rcIndex);
					this.rainwaterSelectionMap.selectByRcIndex(this.rcIndex);
					this.rainwaterSelectionMap.show();
					resultMessageContainer.hide();
				} else {
					resultMessageContainer.show();
				}
			} else {
				// reset values
				citySelect[0].value = null;
				$(FormConfig.selectors.changeWeatherStation).hide();
			}
		})
	}

	resetWeatherStationCheck() {
		/*
		const
			citySelect = $(FormConfig.selectors.citySelect),
			cityInput = $(FormConfig.selectors.cityInput),
			resultMessageContainer = $(FormConfig.selectors.weatherStationCheckResult);

		// reset values
		citySelect[0].value = null;
		cityInput[0].value = '';
		 */

		$(FormConfig.selectors.weatherStationCheckResult).hide();
	}

	setWeatherStationManually() {
		$(FormConfig.selectors.changeWeatherStation).hide();
		$(FormConfig.selectors.weatherStationCheckResult).hide();

		if(!this.rainwaterSelectionMap) {
			if(this.country === FormConfig.values.countries.AUSTRIA) {
				this.rainwaterSelectionMap = new RainwaterSelectionMapAt();
			} else {
				this.rainwaterSelectionMap = new RainwaterSelectionMap();
			}
		} else {
			this.rainwaterSelectionMap.show();
		}
		if(this.rcIndex) {
			this.rainwaterSelectionMap.setViewToGridFeature(this.rcIndex);
			this.rainwaterSelectionMap.selectByRcIndex(this.rcIndex);
		}

		$(FormConfig.selectors.propertyCityDisplay).hide();
		$(FormConfig.selectors.propertyCityInput).show();
	}

	activateGroundReportFilesUpload() {
		$(FormConfig.selectors.groundReportFilesUploadHidden).prop('checked', true);
		$(FormConfig.selectors.soilTypeSelectionContainer).hide().find('input').prop('checked', false);
		$(FormConfig.selectors.groundReportFilesUploadNotification).show();
		this.customRunoffValueInput.val('');
		this.customRunoffValueSignificand.val('');
		this.customRunoffValueExponent[0].selectedIndex = 0;
		this.resolveCustomRunoffValueIndexNotation();
	}

	deactivateGroundReportFilesUpload() {
		$(FormConfig.selectors.groundReportFilesUploadHidden).prop('checked', false);
		$(FormConfig.selectors.soilTypeSelectionContainer).show();
		$(FormConfig.selectors.groundReportFilesUploadNotification).hide();
	}

	customerTypeBasedToggles(customerType) {
		// toggle company input
		const companyInput = $(FormConfig.selectors.companyInput);

		// if is type end customer
		if(customerType === FormConfig.values.customerTypes.END_CUSTOMER) {
			companyInput.val('');
			companyInput.hide();
		} else {
			companyInput.show();
		}

		// toggle graf-partner row
		const grafPartnerRow = $(FormConfig.selectors.grafPartnerRow);
		const grafPartnerCheckbox = $(FormConfig.selectors.grafPartnerCheckbox);

		// if is type end customer or processor
		if(customerType === FormConfig.values.customerTypes.END_CUSTOMER || customerType === FormConfig.values.customerTypes.PROCESSORS) {
			grafPartnerRow.show();
			$(FormConfig.selectors.grafPartnerRow + ' input').prop('disabled', false);
			// only activate partner input if checkbox is checked!
			if (grafPartnerCheckbox.prop('checked') !== true) {
				$(FormConfig.selectors.grafPartnerInput).prop('disabled', true);
			}
		} else {
			grafPartnerRow.hide();
			$(FormConfig.selectors.grafPartnerRow + ' input').prop('disabled', true);
		}
	}

	grafPartnerCheckboxToggle(checked) {
		const grafPartnerInput = $(FormConfig.selectors.grafPartnerInput);
		if (checked) {
			grafPartnerInput.show();
			grafPartnerInput.prop('disabled', false);
		} else {
			grafPartnerInput.hide();
			grafPartnerInput.prop('disabled', true);
		}
	}

	beforeSubmit(e) {
		const citySelect = $(FormConfig.selectors.citySelect);
		// no weather station selected
		if(this.country === FormConfig.values.countries.GERMANY && citySelect[0].selectedIndex !== 0) {
			e.preventDefault();
			this.checkWeatherStation(null, false, true);
			return false;
		}
	}
}
